import React from 'react';
import { Approval } from '../../services/reportReview.service';
import { formatApprovalTime } from './approvalTime';
import './ApprovalBox.css';

interface Props {
  approval: Approval | null;
}

/** 이름 아래 시각(KST MM/DD HH:MM). 시각이 없으면 이름만 */
const Signature: React.FC<{ name: string | null; at: string | null }> = ({ name, at }) => (
  <td>
    {name ?? ''}
    {at && <span className="approval-box__time">{formatApprovalTime(at)}</span>}
  </td>
);

/**
 * 보고서 결재란 — 작성 · 승인 (report-approval-flow SPEC §6.3). 요약 영역 상단 우측에 결재서류처럼 둔다.
 * 조회 전·실패 시에는 그리지 않는다 — 틀린 이름을 보이는 것보다 낫다.
 */
const ApprovalBox: React.FC<Props> = ({ approval }) => {
  if (!approval) return null;
  return (
    <table className="approval-box" aria-label="결재">
      <thead>
        <tr>
          <th scope="col">작성</th>
          <th scope="col">승인</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <Signature name={approval.writer} at={approval.writtenAt} />
          <Signature name={approval.approver} at={approval.approvedAt} />
        </tr>
      </tbody>
    </table>
  );
};

export default ApprovalBox;
